module.exports = __webpack_public_path__ + "img/icon_emergency_disabled.svg";